"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sources = require("@studio/sources");
var _constants = require("@studio/constants");
var _setMultipleDesiredAttendeeMuteStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeMuteStatuses"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function muteSourcesRemovedFromProgram(source) {
  return function (dispatch, getState) {
    var _getState = getState(),
      layers = _getState.program.layers;
    if (layers.length) {
      var sourcesMuteStatus = layers === null || layers === void 0 ? void 0 : layers.reduce(function (acc, layer) {
        if (layer.source.type === _constants.CAMERA_PRESENTER && layer.source._id !== (source === null || source === void 0 ? void 0 : source._id)) {
          var sourceValue = (0, _sources.getSourceValue)(layer.source);
          acc[sourceValue] = true;
        }
        return acc;
      }, {});
      dispatch((0, _setMultipleDesiredAttendeeMuteStatuses["default"])(sourcesMuteStatus));
    }
  };
}
var _default = exports["default"] = muteSourcesRemovedFromProgram;